import { AfterViewChecked, AfterViewInit, Component, Injector, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Kmlmanager } from 'src/app/shared/kmlmanager';
import { Geoutil } from 'src/app/shared/geoutil';
import { Colorutil } from 'src/app/shared/colorutils';
import { environment } from '../../../../environments/environment';
import { LocalizedString } from '@angular/compiler';
import {BeaconscenarioComponent} from '../../beaconscenario/beaconscenario.component';
import {ILatLng,IContourdefinition,IScenarioLayout} from '../../../shared/geointerfaces'
import { ScenariolayoutComponent } from '.././scenariolayout/scenariolayout.component';

@Component({
  selector: 'app-scenarioedittest',
  templateUrl: './scenarioedittest.component.html',
  styleUrls: ['./scenarioedittest.component.css']
})
export class ScenarioedittestComponent extends BaseComponent {
  id = 1
  constructor(injector: Injector) { super(injector) }
  submit(){
    this.router.navigate(['scenarioedit2'],{ queryParams: { id: this.id } })
  }
}
